import { createFileRoute, Outlet } from '@tanstack/react-router';
import FinanceLayout from '@/app/finance/layout';

export const Route = createFileRoute('/finance')({
  component: RouteLayout,
});

function RouteLayout() {
  return (
    <FinanceLayout>
      <Outlet />
    </FinanceLayout>
  );
}
